export default function downloadBinToFile(binData, fileName, type) {
  var zipBlob = new Blob([binData], { type: type })
  var url = URL.createObjectURL(zipBlob)

  angular
    .element('<a/>')
    .attr({
      href: url,
      download: fileName
    })[0]
    .click()
}
